import type { RouteConfig } from "@/types/routestypes";
import React from "react";


// const SignUp = React.lazy(() => import("@/pages/SignUp/SignUp"));
const Login = React.lazy(() => import("@/pages/Login/Login"));
const ForgotPassword = React.lazy(
  () => import("@/pages/ForgotPassword/ForgotPassword")
);
const ForgotPasswordOtp = React.lazy(
  () => import("@/pages/OtpVerification/ForgotPasswordOtp/ForgotPasswordOtp")
);

// const MyTeam = React.lazy(() => import("@/pages/MyTeam/myTeam"));

const DisRegister=React.lazy(()=>import("@/pages/DistributorMerchant/Auth/DisRegister/DisRegister"));
const DisForgotPassword=React.lazy(()=>import('@/pages/DistributorMerchant/Auth/DisForgotPassword/DisForgotPassword'));
const DisLogin=React.lazy(()=>import('@/pages/DistributorMerchant/Auth/DisLogin/DisLogin'));
const DisOtpVerification=React.lazy(()=>import('@/pages/DistributorMerchant/Auth/DisResetPassOtpVerification/Disotp-verification'))

let showSetting = true;
let showReport = true;
let roles: any;
let permissionsArray: any = [];


const routes: {
  routes: Record<string, { path: string; element: React.ReactElement }>;
  publicRoutes: Record<string, { path: string; element: React.ReactElement }>;
  privateRoutes: Record<string, RouteConfig>;
} = {
  routes: {
    LANDING_PAGE: {
      path: "/landing-page",
      element: <div>Landing Page</div>,
    },
  },
  publicRoutes: {
    LOGIN: {
      path: "/login",
      element: <Login />,
    },
    // SIGN_UP: {
    //   path: "/sign-up",
    //   element: <SignUp />,
    // },
    FORGOT_PASSWORD: {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    OTP_VERIFICATION: {
      path: "/otp-verification",
      element: <DisOtpVerification/>,
    },
    FORGOT_PASSWORD_OTP: {
      path: "/forgot-password-verification",
      element: <ForgotPasswordOtp heading="Forget Password!" />,
    },
    EMAIL_VERIFICATION: {
      path: "/email-verification",
      element: <ForgotPasswordOtp heading="Verify your email!" />,
    },
    // SIGNUP_OTPVERIFICATION: {
    //   path: "/signup-verification",
    //   element: <OtpVerification />,
    // },
    // DIS_REGISTER: {
    //   path: "/Disregister",
    //   element: <DisRegister />,
    // },
    // DIS_LOGIN: {
    //   path: "/Dislogin",
    //   element: <DisLogin />,
    // },
    DIS_FORGOT_PASSWORD: {
      path: "/forgot-password",
      element: <DisRegister />,
    },
    DIS_OTP_VERIFICATION: {
      path: "/OTP-verification",
      element: <DisOtpVerification/>,
    },
    
  },
  privateRoutes: {
    // DASHBOARD: DashboardRoutes,
    // MYTEAM: {
    //   path: "/myteam",
    //   element: <MyTeam />,
    //   pageName: "MyTeam",
    //   sidebar: {
    //     show: true,
    //     icon : "/assets/media/teamLogo.svg"
    //   },
    // },
    
  },
} as const;

export default routes;
